<template>
  <div>
    <div class="layer-header">
      <h1 class="header-title">민감정보 수집·이용 동의(필수)</h1>
    </div>
    <div class="layer-content">
      <div class="terms_content">
        <h3>My Pack By Nutrilite 상담을 위한 민감정보 수집·이용동의 (필수)</h3>
        <table>
          <colgroup>
            <col width="33%" />
            <col width="35%" />
            <col width="*" />
          </colgroup>
          <thead>
            <tr>
              <th>수집 항목</th>
              <th>수집 목적</th>
              <th>보유기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="bold">맞춤형 건강기능식품 상담 내용, 고객 건강 정보</td>
              <td>
                맞춤형 건강기능식품 상담, 맞춤형건강기능식품관리사의 직무
                수행내역 등 기록·보관
              </td>
              <td class="bold">
                2년간 또는 건강기능식품법 시행규칙 제16조의 5에서 정한 기간
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          한국암웨이㈜는 회원님의 민감정보를 개인정보보호법, 정보통신망법 등
          관련 법령에 근거하여 수집·보유 및 처리하고 있습니다. 민감 정보의
          수집·이용에 동의하지 않을 수 있으며, 다만 동의하지 않을 경우 "My Pack
          by Nutrilite" 서비스를 이용할 수 없습니다.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TermSensitive",
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
